import axios from "axios";
const jsonConfig = require("../../Config.json");

const getQuestionReportResponse = async (reportdata) => {
    let allResponse = {};
    try {
        const Response = await axios.post(
            jsonConfig.apiUrl + "GetquestionReports", reportdata,
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
        );

        allResponse = Response;

        return Promise.resolve(allResponse);
    }
    catch (error) {
        console.log("errrrrr", error);
        return Promise.reject(error);
    }
}

export default getQuestionReportResponse;